import React from 'react';
import ReactDOM from 'react-dom/client';
import LogRocket from 'logrocket';
import './index.css';
import App from './App';

LogRocket.init('dh8fdf/claw');

ReactDOM.createRoot(document.getElementById('root')).render(<App />);
